<template>
  <v-container fluid grid-list-lg px-0>
    <v-layout>
      <v-flex>
        <v-btn color="primary" @click="calculateReport()" :disabled="calculating" :loading="calculating">
          Сформировать
          <template #loader>
            <span class="loader">
              <v-icon light>cached</v-icon>
            </span>
          </template>
        </v-btn>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import apiIndicators from "@/api/indicators";

export default {
  data: () => ({
    calculating: false,
  }),
  computed: {
    period () {
      return this.$route.params.period
    },
  },
  methods: {
    async calculateReport () {
      this.calculating = true

      try {
        const response = await apiIndicators.calculateNotCountedReport(this.period)
        const headers = this.$store.getters.getResponseHeaders
        const header = headers['content-disposition']
        if (!header) {
          let result = await response.text();
          result = JSON.parse(result)
          throw new Error(result.message || 'Возникла ошибка')
        }
        const filename = header.substring(header.indexOf('"') + 1, header.lastIndexOf('"'))
        const blob = new Blob([response])
        console.log('blob: ', blob)
        console.log('size: ', blob.size)
        console.log('type: ', blob.type)
        const url = window.URL.createObjectURL(new Blob([response]))
        const link = document.createElement('a')
        link.href = url;
        link.setAttribute('download', filename)
        document.body.appendChild(link)
        link.click()
        link.remove()
      } catch (e) {
        this.$events.$emit('notify', {
          message: e.message,
          type: 'error'
        })
      }

      this.calculating = false
    }
  },
}
</script>

<style scoped>
.loader {
  animation: loader 1s infinite;
  display: flex;
}

@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
